module.exports = __webpack_public_path__ + "officialStatic/img/solution-smart-school.3b865b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/solution/solution-smart-school.png
// module id = fXIA
// module chunks = 0